import axios from "axios";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import "../../css/App.css";

const PUB_COUNT_KEY = "portfolio_pub_count";

const NavBar = ({ theme, toggleTheme }) => {
  const [showPublicationsTab, setShowPublicationsTab] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    const cached = sessionStorage.getItem(PUB_COUNT_KEY);
    if (cached !== null) {
      setShowPublicationsTab(Number(cached) > 3);
      return;
    }

    const checkPublicationsCount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/homepage/`,
        );
        const count = response.data.total_publications ?? 0;
        sessionStorage.setItem(PUB_COUNT_KEY, String(count));
        setShowPublicationsTab(count > 3);
      } catch (error) {
        console.error("Error checking publications count:", error);
      }
    };

    checkPublicationsCount();
  }, []);

  return (
    <Navbar
      sticky="top"
      expand="lg"
      className="custom-navbar"
      data-bs-theme={theme}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" aria-label="Home">
          <img
            src={`${process.env.PUBLIC_URL}/Assets/images/logo.svg`}
            alt="Kaustubh Harapanahalli logo"
            width="30"
            height="30"
            className="d-inline-block align-top logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto"></Nav>
          <Nav className="ml-auto">
            <Nav.Link
              as={Link}
              to="/"
              className={`ms-2${isActive("/") ? " nav-link-active" : ""}`}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/news"
              className={`ms-2${isActive("/news") ? " nav-link-active" : ""}`}
            >
              News
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/blogs"
              className={`ms-2${isActive("/blogs") ? " nav-link-active" : ""}`}
            >
              Blogs &amp; Presentations
            </Nav.Link>
            {showPublicationsTab && (
              <Nav.Link
                as={Link}
                to="/publications"
                className={`ms-2${isActive("/publications") ? " nav-link-active" : ""}`}
              >
                Publications
              </Nav.Link>
            )}
            <Nav.Link
              as={Link}
              to="/portfolio"
              className={`ms-2${isActive("/portfolio") ? " nav-link-active" : ""}`}
            >
              Portfolio
            </Nav.Link>
            <Nav.Link
              as="button"
              onClick={toggleTheme}
              className="ms-2 theme-toggle-btn"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "none",
                border: "none",
              }}
              aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
            >
              {theme === "light" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                  style={{ color: "var(--text-primary)" }}
                >
                  <path d="M21 12.79A9 9.01 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                  style={{ color: "var(--text-primary)" }}
                >
                  <circle cx="12" cy="12" r="5"></circle>
                  <line x1="12" y1="1" x2="12" y2="3"></line>
                  <line x1="12" y1="21" x2="12" y2="23"></line>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                  <line x1="1" y1="12" x2="3" y2="12"></line>
                  <line x1="21" y1="12" x2="23" y2="12"></line>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                </svg>
              )}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
